import React, { Component } from 'react';
import autoBind from 'react-autobind';
import Paper from 'material-ui/Paper';
import Dialog from 'material-ui/Dialog';
import TextField from 'material-ui/TextField';
import FontIcon from 'material-ui/FontIcon';
import RaisedButton from 'material-ui/RaisedButton';
import AppBar from 'material-ui/AppBar';

import api from '../api/server_api.js';
import store from '../store/store.js';

class Login extends Component {
  
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = { 
      user: '',
      password: '',
      showErrors: false,
      dialog: false,
      message: '',
      loging: false
    };
  }

  dialogClose() {
    this.setState({dialog: false});
  }

  dialogOpen() {
    this.setState({dialog: true})
  }

  serverError(message) {
    this.setState({message: message});
    this.dialogOpen();
  }

  handleSubmit(event) {
    this.setState({showErrors: false});
    setTimeout(() => this.setState({showErrors: true}), 200);
    event.preventDefault();
    this.state.user.trim() 
      && this.state.password.trim()  
      ? this.submit()
      : null;

    }

  submit(){
    const cb = (data) => {
    this.setState({loging: false});
    if (data) {
      if (data.type === 'ok') {
        store.auth.session = data.session;
        try {
          localStorage.setItem('session', data.session);
          }
          catch (e) {alert('localStorage не поддерживается! Попробуйте использовать другой браузер (Google Chrome)')}
        setTimeout(() => store.replacePage('/'), 200);
        } 
      
      if (data.type === 'error') {
        this.serverError('Не правильное имя пользователя или пароль!');
        }
      }
    else this.serverError('Похоже сервер не доступен :( \n Повторите попытку позже' );
    
    } //end cb

  this.setState({loging: true});
  api.login({user: this.state.user, password: this.state.password}, cb);
  }

  handleChange(event) {
    const name = event.target.name;
    const value = event.target.value
    if (name === 'user') this.setState({ user: value.trim() });
    if (name === 'password') this.setState({ password: value.trim() });
    }

  render() {

    const {user, password, showErrors, message, dialog, loging} = this.state;

    return (
    <div>
      <AppBar
        title = "Онлайн бронировние туров"
        titleStyle = {{textAlign: 'center'}}
        showMenuIconButton = {false}
      />

      <Paper style={{height: 700, padding: 25}}>

        <Dialog
          title="Ошибка"
          modal={false}
          open={dialog}
          onRequestClose={this.dialogClose}
        >
          {message}         
        </Dialog>

        <form onSubmit={this.handleSubmit}>
          <section style={{textAlign: 'center'}}>
          
          <img 
            src='http://www.vizit-tur.ru/local/assets/images/logo.png'
            alt='logo' 
            style={{
              textAlign: 'center',

              maxWidth: '400px'
              }} 
          />
          
          <br/>
          <br/>

              <TextField
                value={user}
                name="user"
                id="user"
                onChange={this.handleChange}
                type='text'
                floatingLabelText='Имя пользователя' 
                errorText={showErrors && !user && 'Введите имя, это важно!'}
              />
            
            <br/>

              <TextField
                value={password}
                name="password"
                id="password"
                onChange={this.handleChange}
                type='password'
                floatingLabelText='Пароль'
                errorText={showErrors && !password && 'Введите пароль, это важно!'} 
              />

            <br/>
            <br/>
            <br/>

            <RaisedButton
              disabled={loging}
              label={loging ? 'Ждите' : 'Отправить' }
              labelPosition="before"
              primary={true}
              icon={<FontIcon className={this.props.icon}/>}
              onClick={this.handleSubmit}
            />


          </section>
        </form>

      </Paper>
      </div>
    );
  }
}

export default Login;


// WEBPACK FOOTER //
// ./src/pages/Login.jsx